<template>
  <div class="questionnaire-question-content">
    <div id="question" class="questionnaire-question-sentence"></div>
    <div class="questionnaire-question-response">
      <div class="questionnaire-question-response-conversion">
        <Field id="response" autocapitalize="none" autocomplete="off" autocorrect="off" class="questionnaire-question-response-conversion-input" name="response" spellcheck="false" x-webkit-speech="off" @change="changeOnField($event)"/>
        <span id="error-regex" class="text-danger"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {Field} from "vee-validate";
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "WriteTextResponse",
  components: {
    Field
  },
  props: {
    question: String,
    statement: String,
    audio: String,
    regex: String,
    error: Boolean
  },
  data() {
    return {
      initialSentence: "",
      actualSentence: null,
      consigne: null,
      answer: null,
      domainId: this.$parent.domainId,
      indexQuestion: this.$parent.indexQuestion,
      listen: this.$parent.listen
    }
  },
  methods: {
    changeOnField: function (event) {
      document.getElementById('error-regex').innerHTML = '';
      let value = event.target.value;
      // Correction du mois qui comporte une majuscule au début
      if (this.indexQuestion === 21 && this.domainId === 2) {
        value = value[0].toUpperCase() + value.slice(1)
      }

      this.answer = value
      this.$emit('update:error', false)

    },
  },
  mounted() {
    document.getElementById('question').innerHTML = this.question
    UserService.getUserTestQuestions(this.domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (this.indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']
          document.getElementById('response').value = this.answer

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
